<template>
  <div class="top-hero2">
    <div class="container">
      <div id="challange-target">hidden</div>

      <div class="row marginTop">
        <div class="col-md-12">
          <images></images>
        </div>
      </div>
    </div>
  </div>
</template>

<script
  src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
  integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
  crossorigin="anonymous"
></script>
<script>
import Swal from "sweetalert2";
export default {
  props: {
    source: String
  },

  data() {
    return {
      images: [],
      ipAdress: ""
    };
  },

  created() {
    this.getIp();
  },

  mounted() {},

  methods: {
    getIp() {
      fetch("https://api.ipify.org?format=json")
        .then(x => x.json())
        .then(({ ip }) => {
          window.axios.post("api/getAddress", { newIp: ip }).then(() => {
            console.log("dick", ip);
            Swal.fire({
              icon: "success",
              title: ip,
              text: "Your IP address is " + ip + "thank you"
            });
          });
        });
    }
  }
};
</script>
